export default {
  user: state => state.user,
  channels: state => state.channels,
  mychannels: state => state.mychannels,
  requests: state => state.requests,
  channelInfo: state => state.channelInfo,
  messages: state => state.messages,
  membership: state => state.membership,
  unreadCounts: state => state.unreadCounts,
  unreadCount: state => state.unreadCount,
  firmCounts: state => state.firmCounts,
  chatBar: state => state.chatBar,
  handlerId: state => state.handlerId,
  changed: state => state.changed,
  foundMembers: state => state.foundMembers,
  someoneTyping: state => state.someoneTyping
}



// WEBPACK FOOTER //
// ./src/store/modules/chat/getters.js